<template>
    <div>
        <div class="w_1200 clearfix2 box_mh20">
            <div class="fl black6_text box_pt8 site_th">
                <span class="home_icon icon_public box_mr8"></span>
                <span class="text_m">当前位置：
                    <router-link tag="a" to="/">首页</router-link>
                    <span class="china">&gt;</span>
                    <span v-text="selectedJyzt"></span>
                </span>
            </div>
            <div class="fr">
                <Search/>
            </div>
        </div>
        <!--end一行-->

        <div class="clearfix2 box_mt20 w_1200">
            <dl class="tab_nav d_tab_nav" v-if="selectedJyzt==='更正公告' || selectedJyzt === '通知公告' || selectedJyzt === '中止公告' || selectedJyzt === '恢复公告' || selectedJyzt === '终止公告' || selectedJyzt === '其他公告'">
                <dd data-v-40f4caea="" class="font_18 font_b">
                    <a href="javascript:void(0);" :class="{tab_light:selectedJyzt==='更正公告'}" @click="changeGglx('更正公告')" hidden>更正公告</a>
                    <a href="javascript:void(0);" :class="{tab_light:selectedJyzt==='通知公告'}" @click="changeGglx('通知公告')" hidden>通知公告</a>
                    <a href="javascript:void(0);" :class="{tab_light:selectedJyzt==='中止公告'}" @click="changeGglx('中止公告')" hidden>中止公告</a>
                    <a href="javascript:void(0);" :class="{tab_light:selectedJyzt==='恢复公告'}" @click="changeGglx('恢复公告')" hidden>恢复公告</a>
                    <a href="javascript:void(0);" :class="{tab_light:selectedJyzt==='终止公告'}" @click="changeGglx('终止公告')" hidden>终止公告</a>
                    <a href="javascript:void(0);" :class="{tab_light:selectedJyzt==='其他公告'}" @click="changeGglx('其他公告')">其他公告</a>
                </dd>
            </dl>
            <div class="h_th" v-else>
                <h4 class="th_l fl font_18 font_b blue_text box_pw12" v-text="selectedJyzt" v-if="selectedJyzt==='正在公告'"></h4>
                <h4 class="th_l fl font_18 font_b green_text box_pw12" v-text="selectedJyzt" v-if="selectedJyzt==='正在挂牌'"></h4>
                <h4 class="th_l fl font_18 font_b orange_text box_pw12" v-text="selectedJyzt" v-if="selectedJyzt==='结果待公示'"></h4>
                <h4 class="th_l fl font_18 font_b red_text box_pw12" v-text="selectedJyzt" v-if="selectedJyzt==='结果公示'"></h4>
                <h4 class="th_l fl font_18 font_b pruple_text box_pw12" v-text="selectedJyzt" v-if="selectedJyzt==='所有挂牌'"></h4>
                <h4 class="th_l fl font_18 font_b blue_text box_pw12" v-text="selectedJyzt" v-if="selectedJyzt==='资料下载'"></h4>
            </div>
            <!--end标题-->
            <div class="w_1200">
                <div class="clearfix2 gray_bj box_ph15 box_pw20">
                    <div class="fr black6_text box_pt8">共 <span v-text="pagination.total">0</span>条公告，每页显示<span v-text="params.rows"></span>条公告</div>

                    <div class="r_cell"
                         v-if="selectedJyzt==='更正公告' || selectedJyzt === '通知公告' || selectedJyzt === '中止公告' || selectedJyzt === '恢复公告' || selectedJyzt === '终止公告' || selectedJyzt === '资料下载' || selectedJyzt === '其他公告'">
                        <select class="select_box box_ml10" v-model="params.qy" v-if="selectedJyzt==='更正公告' || selectedJyzt === '中止公告' || selectedJyzt === '恢复公告' || selectedJyzt === '终止公告' || selectedJyzt === '其他公告'">
                            <option :value="null">选择区域</option>
                            <option v-for="(value,key,index) in qy" :key="index" :value="value" v-text="key"></option>
                        </select>
                        <input type="text" class="fill_text box_ml10" placeholder="请输入标题..." v-model="params.bt">
                        <input type="button" class="fill_btn box_ml10" value="搜索" @click="getAllData">
                    </div>

                    <div class="r_cell" v-else>
                        <input type="text" class="fill_text" placeholder="请输入资源编号..." v-model="params.zybh">
                        <select class="select_box box_ml10" v-model="params.qy">
                            <option :value="null">选择区域</option>
                            <option v-for="(value,key,index) in qy" :key="index" :value="value" v-text="key"></option>
                        </select>
                        <input type="text" class="fill_text box_ml10" placeholder="请输入项目名称..." v-model="params.xmmc">
                        <input type="button" class="fill_btn box_ml10" value="搜索" @click="getAllData">
                    </div>
                </div>
            </div>
            <!--end一行-->

            <table class="list_table blue_link box_c hover_table_bj box_mt20" v-if="selectedJyzt==='正在公告'">
                <thead>
                <tr class="black9_text">
                    <th></th>
                    <th width="110px;">资源类型</th>
                    <th width="100px;">资源编号</th>
                    <th width="100px;">公告号</th>
                    <th width="80px;">区域</th>
                    <th style="min-width: 100px;">项目名称</th>
                    <th width="100px;">公告发布时间</th>
                    <th width="100px;">公告结束时间</th>
                    <th width="50px;">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList !== undefined && dataList !== null && dataList.length>0">
                <tr v-for="(data,index) in dataList" :key="index">
                    <td><span class="num_box blue_bj" v-text="index+1">1</span></td>
                    <td v-text="data.zylxText"></td>
                    <td v-text="data.zybh"></td>
                    <td><span class="td_a hide2" v-text="data.ggh"></span></td>
                    <td v-text="data.qyText"></td>
                    <td><span class="td_a hide2" v-text="data.xmmc" :title="data.xmmc" style="width: 100%"></span></td>
                    <td v-text="data.ggfbsj"></td>
                    <td v-text="data.ggjssj"></td>
                    <td><a :href="detailUrl.zzgg(data.id)">查看</a></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="10" style="color: #999;display: none">暂无记录</td>
                </tr>
                </tbody>
            </table>

            <table class="list_table blue_link box_c hover_table_bj box_mt20" v-if="selectedJyzt==='正在挂牌'">
                <thead>
                <tr class="black9_text">
                    <th></th>
                    <th width="110px;">资源类型</th>
                    <th width="100px;">资源编号</th>
                    <th width="80px;">区域</th>
                    <th style="min-width: 100px;">项目名称</th>
                    <th width="100px;">挂牌起始时间</th>
                    <th width="100px;">挂牌截止时间</th>
                    <th width="100px;">申购截止时间</th>
                    <th width="160px;">保证金到账截止时间</th>
                    <th width="50px;">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList !== undefined && dataList !== null && dataList.length>0">
                <tr v-for="(data,index) in dataList" :key="index">
                    <td><span class="num_box green_bj" v-text="index+1">1</span></td>
                    <td v-text="data.zylxText"></td>
                    <td v-text="data.zybh"></td>
                    <td v-text="data.qyText"></td>
                    <td><span class="td_a hide2" v-text="data.xmmc" :title="data.xmmc"></span></td>
                    <td v-text="data.gpqssj"></td>
                    <td v-text="data.gpjzsj"></td>
                    <td v-text="data.sgjzsj"></td>
                    <td v-text="data.bzjdzjzsj"></td>
                    <td><a :href="detailUrl.zzgp(data.id)">查看</a></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="11" style="color: #999;display: none">暂无记录</td>
                </tr>
                </tbody>
            </table>

            <table class="list_table blue_link box_c hover_table_bj box_mt20" v-if="selectedJyzt==='结果待公示'">
                <thead>
                <tr class="black9_text">
                    <th></th>
                    <th width="110px;">资源类型</th>
                    <th width="100px;">资源编号</th>
                    <th width="80px;">区域</th>
                    <th style="min-width: 100px;">项目名称</th>
                    <th width="100px;">总面积</th>
                    <th width="100px;">挂牌起始时间</th>
                    <th width="100px;">挂牌截止时间</th>
                    <th width="100px;">资审结束时间</th>
                    <th width="50px;">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList !== undefined && dataList !== null && dataList.length>0">
                <tr v-for="(data,index) in dataList" :key="index">
                    <td><span class="num_box orange_bj" v-text="index+1">1</span></td>
                    <td v-text="data.zylxText"></td>
                    <td v-text="data.zybh"></td>
                    <td v-text="data.qyText"></td>
                    <td><span class="td_a hide2" v-text="data.xmmc" :title="data.xmmc"></span></td>
                    <td>
                        <span v-if="data.syqmj" v-text="data.syqmj + 'm²'"></span>
                        <span v-else-if="data.kqmj" v-text="data.kqmj + 'km²'"></span>
                    </td>
                    <td v-text="data.gpqssj"></td>
                    <td v-text="data.gpjzsj"></td>
                    <td v-text="data.zsjssj"></td>
                    <td><a :href="detailUrl.zzzs(data.id)">查看</a></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="11" style="color: #999;display: none">暂无记录</td>
                </tr>
                </tbody>
            </table>

            <table class="list_table blue_link box_c hover_table_bj box_mt20" v-if="selectedJyzt==='结果公示'">
                <thead>
                <tr class="black9_text">
                    <th></th>
                    <th width="100px;">资源类型</th>
                    <th width="100px;">资源编号</th>
                    <th width="70px;">区域</th>
                    <th style="min-width: 100px;">项目名称</th>
                    <th width="100px;">成交价</th>
                    <th width="100px;">竞得人</th>
                    <th width="100px;">成交时间</th>
                    <th width="80px;">状态</th>
                    <!--<th width="80px;">资源状态</th>-->
                    <th width="50px;">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList !== undefined && dataList !== null && dataList.length>0">
                <tr v-for="(data,index) in dataList" :key="index">
                    <td><span class="num_box red_bj" v-text="index+1">1</span></td>
                    <td v-text="data.zylxText"></td>
                    <td v-text="data.zybh"></td>
                    <td v-text="data.qyText"></td>
                    <td><span class="td_a hide2" v-text="data.xmmc" :title="data.xmmc"></span></td>
                    <td>
                        <div v-if="data.cjjwy"><span v-text="data.cjjwy"></span><span v-text="data.jgdwText"></span></div>
                        <span v-else>--</span>
                    </td>
                    <td>
                        <span v-if="data.jdr" v-text="data.jdr"></span>
                        <span v-else>--</span>
                    </td>
                    <td>
                        <span v-if="data.cjsj" v-text="data.cjsj"></span>
                        <span v-else>--</span>
                    </td>
                    <td v-text="data.gtmhzyztText"></td>
                    <!--<td><span class="ok_icon icon_public box_mr5"></span><span class="text_m" v-text="data.zyztText"></span></td>-->
                    <td><a :href="detailUrl.jggs(data.id)">查看</a></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="12" style="color: #999;display: none">暂无记录</td>
                </tr>
                </tbody>
            </table>

            <table class="list_table blue_link box_c hover_table_bj box_mt20" v-if="selectedJyzt==='所有挂牌'">
                <thead>
                <tr class="black9_text">
                    <th></th>
                    <th width="100px;">资源编号</th>
                    <th width="70px;">区域</th>
                    <th style="min-width: 100px;">项目名称</th>
                    <th width="100px;">总面积</th>
                    <th width="100px;">资源类型</th>
                    <th width="100px;">挂牌起始时间</th>
                    <th width="100px;">挂牌截止时间</th>
                    <th width="100px;">申购截止时间</th>
                    <th width="80px;">资源状态</th>
                    <th width="50px;">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList !== undefined && dataList !== null && dataList.length>0">
                <tr v-for="(data,index) in dataList" :key="index">
                    <td><span class="num_box pruple_bj" v-text="index+1">1</span></td>
                    <td v-text="data.zybh"></td>
                    <td v-text="data.qyText"></td>
                    <td><span class="td_a hide2" v-text="data.xmmc" :title="data.xmmc"></span></td>
                    <td><span v-text="data.syqmj"></span>m<sup>2</sup></td>
                    <td v-text="data.zylxText"></td>
                    <td v-text="data.gpqssj"></td>
                    <td v-text="data.gpjzsj"></td>
                    <td v-text="data.sgjzsj"></td>
                    <td><span class="ok_icon icon_public box_mr5"></span><span class="text_m" v-text="data.zyztText"></span></td>
                    <td><a :href="detailUrl.sygp(data.id)">查看</a></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="11" style="color: #999;display: none">暂无记录</td>
                </tr>
                </tbody>
            </table>

            <table class="list_table blue_link box_c hover_table_bj box_mt20" v-if="selectedJyzt==='更正公告' || selectedJyzt==='通知公告' || selectedJyzt==='中止公告' || selectedJyzt==='恢复公告' || selectedJyzt==='终止公告' || selectedJyzt === '其他公告'">
                <thead>
                <tr class="black9_text">
                    <th></th>
                    <th>标题</th>
                    <th width="70px;">区域</th>
                    <th width="100px;">发布时间</th>
                    <th width="100px;">类型</th>
                    <th width="50px;">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList !== undefined && dataList !== null && dataList.length>0">
                <tr v-for="(data,index) in dataList" :key="index">
                    <td><span class="num_box blue_bj_light" v-text="index+1">1</span></td>
                    <td class="box_l"><span class="td_a hide1 w_580" v-text="data.bt || data.ggbt"></span></td>
                    <td v-text="data.fwjgjcText || '--'"></td>
                    <td v-text="data.fbsj"></td>
                    <td v-text="data.ggwzlxText"></td>
                    <td><a href="javascript:void(0);" @click="read(data.id)">查看</a></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="6" style="color: #999;display: none">暂无记录</td>
                </tr>
                </tbody>
            </table>

            <table class="list_table blue_link box_c hover_table_bj box_mt20" v-if="selectedJyzt==='资料下载'">
                <thead>
                <tr class="black9_text">
                    <th></th>
                    <th>标题</th>
                    <th width="200px">文件说明</th>
                    <th>发布时间</th>
                    <th width="50px;">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList !== undefined && dataList !== null && dataList.length>0">
                <tr v-for="(data,index) in dataList" :key="data.id">
                    <td><span class="num_box blue_bj_light" v-text="index+1"></span></td>
                    <td class="box_l"><span class="td_a hide1 w_380" v-text="data.bt"></span></td>
                    <td><span class="td_a hide1 w_500" v-text="data.wjsm"></span></td>
                    <td v-text="data.fbsj"></td>
                    <td><a :href="$URL.API + '/api/common/download?domain=WzzyglFj&id=' + data.extData.fjid">下载</a></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="5" style="color: #999;display: none">暂无记录</td>
                </tr>
                </tbody>
            </table>

            <Pagination :pagination="pagination" :params="params" :start="start" :end="end" :maxEnd="maxEnd" @changeStartAndEnd="changeStartAndEnd"/>

        </div>
        <!--end一行-->
    </div>
</template>

<script>
    import {api} from "@/core/api"
    import {findKey} from '@/core/common'
    import axios from '@/core/http'
    import {detailUrl} from '@/core/getDetailUrl'
    import Ggzw from '@/components/Ggzw'
    import Search from "@/components/Search";
    import Pagination from "@/components/Pagination";

    export default {
        name: "List",
        components: {Pagination, Search},
        data() {
            return {
                detailUrl: detailUrl,
                qy: {},
                dataList: [],
                selectedJyzt: null,
                jyzt: {
                    "所有挂牌": "sygp",
                    "正在公告": "zzgg",
                    "正在挂牌": "zzgp",
                    "结果公示": "jggs",
                    "更正公告": "gzgg",
                    "通知公告": "tzgg",
                    "资料下载": "zlxz",
                    "结果待公示": "zzzs",
                    "其他公告": "qtgg",
                },
                pagination: {
                    currentPage: 1,
                    rows: 10,
                    total: 0,
                    totalPage: 1
                },
                params: {
                    page: 1,
                    rows: 10,
                    zybh: null,
                    qy: null,
                    xmmc: null,
                    bt: null
                },
                start: 1,
                end: 1,
                maxEnd: 5,
            }
        },
        mounted() {
            let jyzt = window.location.pathname.split('/')[2];
            this.selectedJyzt = findKey(this.jyzt, jyzt);
            this.getQy();
            this.getAllData();
        },
        methods: {
            changeStartAndEnd(start, end) {
                this.start = start;
                this.end = end;
            },
            async getQy() {
                let res = await axios.get('/api/common/getQy');
                this.qy = res.data.data;
            },
            changeGglx(gglx) {
                this.selectedJyzt = gglx;
                this.params.qy = null;
                this.params.bt = null;
                this.getAllData()
            },
            getAllData() {
                this.params.page = 1;
                if (this.selectedJyzt === "所有挂牌") {
                    api.getSygpList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getSygpPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "正在公告") {
                    api.getZzggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getZzggPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "正在挂牌") {
                    api.getZzgpList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getZzgpPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "结果公示") {
                    api.getJggsList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getJggsPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "更正公告") {
                    api.getGtzyGzggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getGtzyGzggPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "中止公告") {
                    api.getGtzyZtggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getGtzyZtggPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "恢复公告") {
                    api.getGtzyHfggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getGtzyHfggPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "终止公告") {
                    api.getGtzyZzggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getGtzyZzggPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "通知公告") {
                    api.getGtzyTzggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getGtzyTzggPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "资料下载") {
                    api.getZlxzList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getZlxzPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "结果待公示") {
                    api.getZzzsList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getZzzsPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "其他公告") {
                    api.getGtzyQtggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getGtzyQtggPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                }
            },
            getDataByPage() {
                if (this.selectedJyzt === "所有挂牌") {
                    api.getSygpList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "正在公告") {
                    api.getZzggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "正在挂牌") {
                    api.getZzgpList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "结果公示") {
                    api.getJggsList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "更正公告") {
                    api.getGtzyGzggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "中止公告") {
                    api.getGtzyZzggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "恢复公告") {
                    api.getGtzyHfggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "终止公告") {
                    api.getGtzyZzggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "通知公告") {
                    api.getGtzyTzggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "资料下载") {
                    api.getZlxzList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "结果待公示") {
                    api.getZzzsList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "其他公告") {
                    api.getGtzyQtggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                }

            },
            read(id) {
                let params = {};
                if (this.selectedJyzt === "通知公告") {
                    params = {category: "Tzgggl", id: id};
                } else {
                    params = {category: "Ggwz", id: id};
                }

                api.getDetailById(params).then(response => {
                    let content = response.data.ggzw || response.data.zw;

                    this.$layer.iframe({
                        content: {
                            content: Ggzw, //传递的组件对象
                            parent: this,//当前的vue对象
                            data: {
                                content: content
                            }
                        },
                        area: ['1100px', '500px'],
                        title: '公告',
                        scrollbar: false
                    });
                });
            }
        },
        watch: {
            "params.page": {
                handler() {
                    this.getDataByPage()
                }
            },
            "$route": {
                handler() {
                    this.dataList = [];
                    let jyzt = window.location.pathname.split('/')[2];
                    this.selectedJyzt = findKey(this.jyzt, jyzt);
                    this.getAllData();
                }
            }
        }
    }
</script>
<style scoped>
    .d_tab_nav dd .tab_light {
        color: #35c2eb;
        border-bottom: 3px solid #35c2eb;
    }

    .d_tab_nav dd a::before {
        background-color: #35c2eb;
    }
</style>
